<template>
    <div>
       <search @find="getSearch"></search>
        <div class="page-wrapper">
        <table-list 
            title="门禁/梯控设备列表"
            :columns="columns"
            :data="data"
            :total="total"
            :current="current"
            :loading="loading" 
            @change-page="changePage">
            <Button type="primary" class="btn" @click="bindHander" v-p="{api:'elevDevice/addDevice'}">绑定设备</Button>
            <Button type="primary" class="btn" @click="refreshDevice">刷新设备状态</Button>
        </table-list>
        </div>
        <ladder-model 
            v-model="showModal" 
            @refresh="refreshDevice"></ladder-model>
        <ladder-model 
            v-model="editModal" 
            title="修改设备" 
            type="edit" 
            :deviceId="deviceId" 
            @refresh="freshList"></ladder-model>
    </div>
</template>
 
<script type="text/ecmascript-6">
import Search from './components/Search';
import TableList from 'components/TableList';
import LadderModel from './components/Laddermodel';
import { getDeviceList,delDevice,openDoor } from 'api/ladder.js';
export default {
    name:'ladderDevice',
    components: {
        Search,
        TableList,
        LadderModel
    },
    data () {
        return {
            data:[],
            total:0,
            current : 1,
            loading:false,
            showModal:false,
            editModal:false,
            deviceId:null,
            columns:[
              {
                type: 'index',
                width: 60,
                align: 'center'
              },
              {
                title: '项目名称',
                align: 'center',
                key: 'projectName',
                width: 200,
              },
              {
                title: '楼栋',
                align: 'center',
                key: 'buildingName',
                width: 100,
              },
              {
                title: '最高楼层',
                align: 'center',
                key: 'highestFloor',
                width: 100,
              },
              {
                title: '最低楼层',
                align: 'center',
                key: 'lowestFloor',
                width: 100,
              },
              {
                title: '设备类型',
                align: 'center',
                key: 'deviceTypeDesc',
                width: 100,
              },
              {
                title: '设备名称',
                align: 'center',
                key: 'deviceName',
                width: 200,
              },
              {
                title: '设备ID',
                align: 'center',
                key: 'deviceId',
                width: 100,
              },
              {
                title: '设备sn码',
                align: 'center',
                key: 'deviceSn',
                width: 200,
              },
              {
                title: '设备添加时间',
                align: 'center',
                key: 'createTime',
                width: 200,
              },
              {
                title: '设备状态',
                align: 'center',
                key: 'deviceStatus',
                width: 200,
                render: (h, params) => {
                  return h('div', [h('p', {}, params.row.deviceStatusDesc), h('p', {}, params.row.onlineUpdateTime)])
                }
              },
              {
                title: '操作',
                key: 'action',
                width: 200,
                align: 'center',
                fixed: 'right',
                render: (h, params) => {
                  return h('div', [h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small'
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'elevDevice/updateDevice'
                        }
                      }
                    ],
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.deviceId = params.row.deviceId;
                        this.editModal = true;
                      }
                    }
                  }, '修改'), h('Button', {
                    props: {
                      type: 'ghost',
                      size: 'small',
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'elevDevice/deleteDevice'
                        }
                      }
                    ],
                    style: {
                      marginRight: '5px'
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '删除',
                          content: '删除设备后无法恢复，确认删除本设备么？',
                          onOk: () => {
                            this.delDeviceHander(params.row.deviceId)
                          }
                        })
                      }
                    }
                  }, '删除'), h('Button', {
                    props: {
                      type: 'primary',
                      size: 'small',
                      disabled: params.row.deviceStatus === 0
                    },
                    directives: [
                      {
                        name: 'p',
                        value: {
                          api: 'elevDevice/remoteOpenDoor'
                        }
                      }
                    ],
                    on: {
                      click: () => {
                        this.openDoorHander(params.row.deviceId)
                      }
                    }
                  }, '远程开门')])
                }
              }
            ],
            params:{
                projectFid:'',  //项目fid
                buildingFid:'', // 楼栋fid
                deviceType:'',
                deviceSn:'',
                limit:10,
                page:1,
                isRefresh:0  //0：否，1：是
            }
        }
    },
    created () {
        this.initList();  
    },
    methods: {
        changePage(n) {
            this.params.page = n;
            this.current = n;
            this.params.isRefresh = 0;
			this.initList();
        },
        bindHander() {
            this.showModal = true;
        },
        getSearch(params){
            params.isRefresh = 0;
            this.current = 1;
            this.params = JSON.parse(JSON.stringify(params));
            this.initList();
        },
        initList() {
            getDeviceList(this.params).then(res => {
                console.log(res);
              res.data.rows && ( this.data = res.data.rows);
                this.total = res.data.total;
            })
        },
        refreshDevice() {
            this.params.isRefresh = 1;
            this.initList();
        },
        freshList() {
            this.params.isRefresh = 0;
            this.initList();
        },
        delDeviceHander(deviceId) {
            delDevice({deviceId}).then(res => {
                this.freshList();
            })
        },
        openDoorHander(deviceId) {
            openDoor({deviceId}).then(res => {
                this.$Message.success('开门成功');
                this.freshList();
            })
            .catch(error => {
                this.refreshDevice();
            })
        }

    }
}
</script>
 
<style lang="css" scoped>
.btn{
    margin-bottom: 20px;
}
</style>
